module.exports = __webpack_public_path__ + "static/media/_albania.c2b05705.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_albania.svg
// module id = 2300
// module chunks = 7